import FileSaver from "file-saver";

function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(",")[1]); // write the bytes of the string to an ArrayBuffer

  const ab = new ArrayBuffer(byteString.length); // create a view into the buffer

  const ia = new Uint8Array(ab); // set the bytes of the buffer to the correct values

  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  } // write the ArrayBuffer to a blob, and you're done


  const blob = new Blob([ab], {
    type: "application/pdf"
  });
  return blob;
}

export default function download(data, strFileName, strMimeType) {
  const blob = dataURItoBlob(data);
  FileSaver.saveAs(blob, "dpd-chat-transcript.pdf");
}